<template>
  <v-app>
    <Navbar />

    <v-content :class="noBackgroundPages">
      <v-dialog v-model="dialog" persistent max-width="800" v-if="$route.path">
        <v-card>
          <v-row no-gutters class="text-center">

          <v-col cols="12" xl="4" md="4" sm="12" class="pointer modal-help" @click="helpNeeded()">
            <h2 class="pa-12 custom-modal">Потребна ми је помоћ</h2>
          </v-col>
            <v-col cols="12" xl="4" md="4" sm="12" class="pointer modal-donate"  @click="wannaDonate()">
              <h2 class="pa-12 custom-modal">Желим да донирам</h2>
            </v-col>

            <v-col cols="12" xl="4" md="4" sm="12" class="pointer modal-volu"  @click="wannaVolu()">
              <h2 class="pa-12">Желим да волонтирам</h2>
            </v-col>
          </v-row>

         <!-- <v-card-title class="headline">Use Google's location service?</v-card-title>
          <v-card-text>Let Google help apps determine location. This means sending anonymous location data to Google, even when no apps are running.</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="dialog = false">Disagree</v-btn>
            <v-btn color="green darken-1" text @click="dialog = false">Agree</v-btn>
          </v-card-actions>-->
        </v-card>
      </v-dialog>
      <router-view>

      </router-view>
    </v-content>
  </v-app>
</template>

<script>
import Navbar from "./components/layout/Navbar";
export default {
  name: "App",
  components: { Navbar },
  data: () => ({
    dialog: true,
  }),
  created () {
    this.checkRoute();
  },
  methods:{
    checkRoute(){
      if(this.$route.path !== '/volontiraj' && this.$route.path !== '/kompanije' && this.$route.path !== '/') this.dialog = false;
    },
    helpNeeded(){
      this.$router.push('/')
      this.dialog = false;
    },
    wannaDonate(){
      this.$router.push('/kompanije')
      this.dialog = false;
    },
    wannaVolu(){
      this.$router.push('/volontiraj')
      this.dialog = false;
    },

  },
  computed:{
    noBackgroundPages(){
      if (this.$route.path == '/o-nama' || this.$route.path == '/' ) return ''
      return 'background'
    },
  },
};
</script>
<style>
  @import './assets/animate.css';

a {
  text-decoration: none;
  color: #000 !important;
}
  .background{
/*    background: rgb(48,118,210);
    background: linear-gradient(139deg, rgba(48,118,210,1) 35%, rgba(48,159,210,1) 69%);*/

  }
  .img-form{
    margin: 0 auto;
  }
  .v-toolbar__title{
    color: #1976d2 !important;
    font-size: 25px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 1px;
  }
  .h-full{
    height: 100%;
  }
  .w-full{
    width: 100%;
  }
  .pointer{
    cursor: pointer;
  }
/*.custom-modal{
  border-right: solid 1px #b9b2b2;
}*/
  .modal-donate{
  background: #0d4077;
  color: white;

}
  .modal-help{
   background: #c7363d;
    color: white;
 }
 .modal-volu{

 }
.modal-help:hover{
  color: #0d4077;
}
  .modal-donate:hover{
    color:#c7363d;
  }
.modal-volu:hover{
  color:#0d4077
}

/*  @media only screen and (max-width: 768px) {
    .custom-modal{
      border-bottom: solid 1px #b9b2b2;
    }
  }*/
  .cover-img{
    max-width: 250px;
  }
  .hero-logo{
    display: flex;
    justify-content: flex-start;
    align-items: flex-start!important;
  }
  @media only screen and (max-width: 375px){
    .modal-donate{
      height: 168px;
      display: flex;
      align-items: center;
    }
  }
  @media only screen and (max-width: 425px){
    .hero-logo{
      justify-content: center;
    }
  }
  @media only screen
  and (max-width : 1600px)
  and (max-height : 2560px) and (min-width: 769px){
    .v-dialog.v-dialog--active.v-dialog--persistent{
      padding-top: 250px;
      box-shadow: none;
    }
    .v-card.v-sheet.theme--light{

      -webkit-box-shadow: 0px 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12);
      box-shadow: 0px 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12);
    }
  }
</style>

